import React, { useState, useEffect } from "react";
import { Box, Typography, Stack, Alert, AlertTitle } from "@mui/material";
import Input from "../Base/Input";
import SubmitButton from "../common/SubmitButton";
import { useTranslation } from "react-i18next";
import Backdrop from "../common/Backdrop";
import LoadingDots from "../Lottie/LoadingDots";
import { useNavigate, useParams } from "react-router-dom";
import Config from "../../Config";
import { apis } from "../../services/apiService";
import styles from "../../Style/Modules/loginPay.module.css";
import "../../Style/Theme/index.css";

import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import DirectionsIcon from "@mui/icons-material/Directions";
import loginImg from "./tyger_logo_animation_loader.gif";

import {
  VerifyMobile,
  calculateUserBlockTimer,
  constant,
  convertSEcToMin,
  login,
  refreshCacheAndReload,
} from "../../utils/utils";
import useSelector from "../../store/selector";
import { CONSTANTS } from "../../utils/constant";
import { encryptApiData } from "../../utils/apiEncryption";
export default function LoginFormPay() {
  const { setRecoilVal, getRecoilVal } = useSelector();
  const { Source, Anchor, Program } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [mobile, setmobile] = useState("");
  const [mobileErr, setMobileErr] = useState();
  const [finalErr, setFinalErr] = useState("");
  const [countTimer, setCountTimer] = useState(CONSTANTS.BLOCKUSERTIMER);
  let errors = {
    1: t("Enter valid mobile number."),
    2: t("Invalid user.Please enter correct mobile number or Signup."),
    3: t("Mobile number should not start with 0"),
  };
  useEffect(() => {
    // login({
    //   screen: "pay",
    //   anchor: Anchor,
    //   program: Program,
    //   source: Source,
    //   loginLogoutVal: constant.LOGOUT_VALUE,
    // });
    // calculateUserBlockTimer();
    async function fun() {
      refreshCacheAndReload();
      let data = {
        screen: "pay",
        anchor: Anchor,
        program: Program,
        source: Source,
        loginLogoutVal: constant.LOGOUT_VALUE,
      };
      setRecoilVal(constant.atomsName.USER_DETAIL, await login(data));
    }
    fun();
  }, []);

  const callSubmitFun = async () => {
    try {
      setLoading(true);
      const reqData = {
        mn: mobile,
        src: Source,
        anch: Anchor,
        pr: Program,
      };
      let resp = await apis.postApi(Config.RepaymentUrl + "OTP/SendOTP_N", {
        request: encryptApiData(reqData),
      });
      let result = await resp.json();
      if (resp.status === 200) {
        setLoading(false);
        const data = {
          mn: mobile,
          AppId: result?.data?.custId,
          em: "",
          isEmail: false,
          LMS: result.data.lms,
          source: Source,
          anchor: Anchor,
          program: Program,
        };
        navigate("/payotp_p", { state: data });
      }
    } catch (error) {
      let errorMsg = JSON?.parse(error?.message);
      setFinalErr(errorMsg?.statusMessage);
      setLoading(false);
    }
  };
  let handleSubmit = async (e) => {
    e.preventDefault();
    let storedData = getRecoilVal(constant.atomsName.USER_BLOCKER);
    let finalVal = await calculateUserBlockTimer(
      mobile,
      storedData,
      setCountTimer,
      setRecoilVal,
      Source,
      Anchor,
      Program
    );
    // console.log("countTimer-------", timeDef);
    // if (timeDef <= 0) {
    //   await callSubmitFun();
    // }
    if (!finalVal.anchorProgramMatched) {
      await callSubmitFun();
    } else if (finalVal.timeDef <= 0 && finalVal.anchorProgramMatched) {
      await callSubmitFun();
    }
  };

  const handleChange = (e) => {
    setmobile(e.target.value);
    setCountTimer(0);
    if (e?.target?.value && !VerifyMobile(e?.target?.value)) {
      parseInt(e.target.value.charAt(0)) === 0
        ? setMobileErr(errors[3])
        : setMobileErr(errors[1]);
    } else {
      setMobileErr("");
    }
  };

  return (
    <>
      <Box
        component="form"
        noValidate
        id="loginPayForm"
        autoComplete="off"
        onSubmit={handleSubmit}
        className={styles.loginPayBox}
        sx={{
          // p: "2px 2px",
          // mb: "10px",
          // top: "45%",
          // width: 400,
          marginTop: "300px",
          bgcolor: "#e9e9e9",
          position: "absolute",
          backgroundColor: "#29417c",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
          <Box>
            <Input
              className="loginPage inputbg_Th"
              sx={{ width: "280px", color: "white" }}
              type="tel"
              name="phoneNumber"
              autoComplete="off"
              value={mobile}
              error={mobileErr}
              label="Mobile number"
              onChange={handleChange}
              mb={1}
            />
          </Box>

          <IconButton
            aria-label="directions"
            disabled={!mobile || mobileErr}
            type="submit"
          >
            <DirectionsIcon
              sx={{
                fontSize: 45,
                // mt: 1,
                color: !mobile || mobileErr ? "#666666" : "#a6ce39",
              }}
            />
          </IconButton>
        </Box>
        <Box sx={{ mx: 4, mt: -1.5 }}>
          {mobileErr && (
            <Box mt={-2} ml={0}>
              <Typography
                variant="p"
                color="subtitle"
                sx={{ color: "#D9416C" }}
              >
                {mobileErr}
              </Typography>
            </Box>
          )}
          {countTimer > 0 && (
            <Box sx={{ color: "red" }} mt={-3} mb={1} ml={1}>
              {mobile.length === 10 &&
                countTimer > 0 &&
                // localStorage.getItem("blocker") !== null &&
                `You Have Exceed the Limit of verifying OTP, Please wait for ${convertSEcToMin(
                  countTimer
                )} minute`}
            </Box>
          )}
          {loading && (
            <Backdrop ax="center">
              <img
                src={loginImg}
                style={{
                  backgroundColor: "#072b8240",
                  // "#072b822b",
                  // "#4c69b1",
                  // opacity: "0.8",
                  width: "200px",
                  height: "150px",
                  marginLeft: "25%",
                  borderRadius: "10px",
                }}
              />
            </Backdrop>
          )}
          {finalErr && (
            <Backdrop ax="center">
              <Stack
                sx={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Alert
                  severity="error"
                  sx={{ width: "80%", borderRadius: "15px" }}
                  onClose={() => {
                    setFinalErr("");
                  }}
                >
                  <AlertTitle>Error</AlertTitle>
                  <strong className="errorMsg_Th">{finalErr}</strong>
                </Alert>
              </Stack>
            </Backdrop>
          )}
        </Box>
      </Box>
    </>
  );
}
